var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    _vm.embedded ? "div" : "gg-card",
    {
      tag: "component",
      attrs: {
        id: "create-filter"
      }
    },
    [
      !_vm.embedded
        ? _c("gg-card-header", [_vm._v(" " + _vm._s(_vm.componentTitle) + " ")])
        : _vm._e(),
      _c(
        _vm.embedded ? "div" : "gg-card-text",
        {
          tag: "component"
        },
        [
          _c(
            "v-form",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          outlined: "",
                          label: "Filter Name",
                          "data-vv-name": "filtername",
                          "data-vv-as": "Filter name",
                          "error-messages": _vm.errors.collect("filtername")
                        },
                        model: {
                          value: _vm.model.filtername,
                          callback: function callback($$v) {
                            _vm.$set(_vm.model, "filtername", $$v)
                          },
                          expression: "model.filtername"
                        }
                      }),
                      _vm._v(
                        " The filter name must be unique. If you give the filter the same name as another filter, the previous filter will be overwritten. "
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("gg-input-label", [_vm._v("Rules")]),
                      _vm._l(_vm.rules, function(row, index) {
                        return _c(
                          "div",
                          {
                            key: row.id
                          },
                          [
                            _c("rules", {
                              attrs: {
                                index: row,
                                index_in_array: index,
                                array_length: _vm.rules.length,
                                rule: _vm.editedRuleData[row.id - 1]
                              },
                              on: {
                                add: function add($event) {
                                  return _vm.addRuleItem("rule")
                                },
                                remove: function remove($event) {
                                  return _vm.removeRuleItem("rule", row)
                                },
                                sort_up: _vm.moveFilter,
                                sort_down: _vm.moveFilter,
                                changed: _vm.setRules
                              }
                            }),
                            _c("v-divider")
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("gg-input-label", [_vm._v("Actions")]),
                      _vm._l(_vm.rule_actions, function(row) {
                        return _c(
                          "div",
                          {
                            key: row.id
                          },
                          [
                            _c("actions", {
                              attrs: {
                                index: row,
                                action: _vm.editedActionData[row.id - 1]
                              },
                              on: {
                                add: function add($event) {
                                  return _vm.addRuleItem("action")
                                },
                                remove: function remove($event) {
                                  return _vm.removeRuleItem("action", row)
                                },
                                changed: _vm.setRules
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  !_vm.embedded
                    ? _c(
                        "v-col",
                        {
                          staticClass: "mt-0 pt-0",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                tile: "",
                                elevation: "0",
                                color: "primary",
                                disabled: _vm.loading,
                                loading: _vm.loading
                              },
                              on: {
                                click: _vm.addRule
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.buttons.add) + " ")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                text: "",
                                elevation: "0",
                                color: "primary"
                              },
                              on: {
                                click: _vm.onReset
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.buttons.reset) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }